import Swiper from 'swiper';
import mq from './helper.mq';
// import 'swiper/css/swiper.css'

/*
 *  Class Teaser
 */
export
default class Teaser {
    constructor() {
        this.teasers = document.querySelectorAll('.teaser:not(.preview)');
        this.swiperDefaultSetup = {
            spaceBetween: 50,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            resizeEvent: 'resize'
        };
        this.swiperSecondSetup = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 50,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30
                },
            }
        };
        this.swiperThirdSetup = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 50,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 40
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 40
                },
            }
        };
        this.swiperFifthSetup = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20
                },
                640: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 30
                },
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 40
                },
                1024: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    spaceBetween: 40
                },
            }
        };

        this.videoBreakpointVisibilityMap = {
            xxxs: 'teaser__background--video-mobile',
            xxs: 'teaser__background--video-mobile',
            xs: 'teaser__background--video-desktop',
            sm: 'teaser__background--video-desktop',
            md: 'teaser__background--video-desktop',
            lg: 'teaser__background--video-desktop',
            xl: 'teaser__background--video-desktop',
            xxl: 'teaser__background--video-desktop',
            xxxl: 'teaser__background--video-desktop',
        };

        this.swipers = [];

        this.lastBreakpoint = '';
    }

    init() {

        this.swipers = [];

        this.lastBreakpoint = mq.getBreakpoint();

        this.teasers.forEach(function (teaser) {
            const slides = teaser.querySelectorAll('.swiper-slide');
            if (slides.length < 2) return;

            teaser.classList.remove('teaser__hide-controls');
            let swiper = null;

            if (teaser.classList.contains('teaser__default')) {
                swiper = new Swiper(teaser, this.swiperDefaultSetup);
            }

            if (teaser.classList.contains('teaser__second')) {
                swiper = new Swiper(teaser, this.swiperSecondSetup);
            }

            if (teaser.classList.contains('teaser__third')) {
                swiper = new Swiper(teaser, this.swiperThirdSetup);
            }

            if (teaser.classList.contains('teaser__fifth')) {
                swiper = new Swiper(teaser, this.swiperFifthSetup);
            }

            if (swiper) {

                this.swipers.push(swiper);

                swiper.on('slideChange', () => this.updateVideoState(swiper));

                window.addEventListener('resize', () => {
                    // swiper.reInit()
                    const currentBreakpoint = mq.getBreakpoint();
                    if (currentBreakpoint === this.lastBreakpoint) {
                        return;
                    }

                    this.lastBreakpoint = currentBreakpoint;
                    this.swipers.forEach(swiper => this.updateVideoState(swiper));
                });
            }
        }.bind(this));
    };

    updateVideoState(swiper) {
        for (let i = 0; i < swiper.slides.length; i++) {
            let videoElements = swiper.slides[i].querySelectorAll('video.teaser__background--video');
            if (videoElements.length) {
                videoElements.forEach((videoElement) => {
                    if (
                        i === swiper.realIndex && ( // play only if it's current slide
                            videoElements.length === 1 || //if there is only one video defined
                            videoElement.classList.contains(this.videoBreakpointVisibilityMap[this.lastBreakpoint]) //or there are many but this one matches current breakpoint
                        )
                    ) {
                        videoElement.play();
                    } else {
                        videoElement.pause();
                    }
                });
            }
        }
    }
}
